/* tslint:disable */
/* eslint-disable */
export enum QuestionnaireInstanceStatus {
  Initialised = 'Initialised',
  Started = 'Started',
  Declined = 'Declined',
  Finished = 'Finished',
  FinishedEarly = 'FinishedEarly',
  Resumed = 'Resumed'
}
